import { render } from "./EmployeeDependents.vue?vue&type=template&id=1f156da2&scoped=true"
import script from "./EmployeeDependents.vue?vue&type=script&lang=js"
export * from "./EmployeeDependents.vue?vue&type=script&lang=js"

import "./EmployeeDependents.vue?vue&type=style&index=0&id=1f156da2&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f156da2"]])

export default __exports__